import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage, FormattedHTMLMessage, intlShape, injectIntl} from 'react-intl';
import * as AppMarketSdk from '../services/wrapped-app-market-sdk';
import {runAddApp, addAppClientData} from '../services/app-flow';
import {cdnResize} from '../services/utils';
import {isExperiment} from '../config';
import classNames from 'classnames';
import {execBI} from '../services/bi-events-manager';

const onAgree = (ev, app, props) => {
  ev.preventDefault();
  execBI('PERMISSIONS_MODAL_AGREE');

  if (props.close) {
    props.close();
  } else {
    AppMarketSdk.closeModal('add');
    // AppMarketSdk.closeAppPopup(); // do you have to close App-modal, is it open?
  }

  const config = {
    formatMessage: props.intl.formatMessage,
    experiments: props.experiments,
    query: props.query,
    market: props.market,
    fullUrl: props.fullUrl
  };

  runAddApp(addAppClientData(app, false), props.dispatch, config);
};

const onDisagree = (ev, close) => {
  ev.preventDefault();
  execBI('PERMISSIONS_MODAL_CLOSE', {method: 'cancel'});
  if (close) {
    close();
  } else {
    AppMarketSdk.closeModal('cancel');
  }
};


class Permissions extends React.Component {

  componentDidMount() {
    execBI('PERMISSIONS_MODAL_OPEN', {app: this.props.app});
  }

  render() {
    const {app, isDemoMode, close} = this.props;
    const showSecurityNotice = isExperiment('specs.market.SecurePermissions', this.props.experiments) && !app.listedInMarket;

    return (
      <div className="permission-container">
        <div className={classNames('permission-request', {'application-not-listed': showSecurityNotice})}>
          <div className="body">
            <div className="application-info">
              <img className="application-logo" src={cdnResize(app.appIcon, 60, 60)} width="60px" height="60px"/>

              <div className="application-title typography_h2">{app.name}</div>

              <div className="application-producer typography_t1">
                <FormattedMessage id="permissionRequest.providedToYouBy"/> <span>{app.by}</span>
              </div>

              {showSecurityNotice ?
                <div className="application-notice">
                  <FormattedMessage id="permissionRequest.notListedInMarket"/>
                </div> : null }
            </div>

            <div className="controls">
              <a className="disagree button-secondary button-small" href="#" onClick={(ev) => onDisagree(ev, close)}>
                <FormattedMessage id={isDemoMode ? 'permissionRequest.demoMode.disagree' : 'permissionRequest.cancel'}/>
              </a>
              <a className="agree button-primary plus-sign button-small" href="#" onClick={(ev) => onAgree(ev, app, this.props)}>
                <FormattedMessage id={isDemoMode ? 'permissionRequest.demoMode.v14.agree' : 'permissionRequest.addApp'}/>
              </a>
            </div>
          </div>
          <div className="foot">
            <div className="terms typography_t3_1" onClick={() => execBI('PERMISSIONS_MODAL_TERMS')}>
              <FormattedHTMLMessage id={isDemoMode ? 'permissionRequest.demoMode.terms' : 'permissionRequest.terms'}/>
            </div>
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    isDemoMode: PropTypes.bool.isRequired,
    close: PropTypes.func,
    dispatch: PropTypes.func,
    intl: intlShape,
    experiments: PropTypes.object,
    market: PropTypes.string,
    query: PropTypes.object,
    fullUrl: PropTypes.string
  }
}

function mapStateToProps(state) {
  return {
    experiments: state.mode.experiments,
    query: state.mode.query,
    market: state.mode.market,
    fullUrl: state.mode.fullUrl
  };
}

export default connect(mapStateToProps)(injectIntl(Permissions));



// WEBPACK FOOTER //
// ./components/Permissions.js